import request from '@/utils/request'

// 1、获取账户概览金额
export function getUserAccount(query) {
  return request({
    url: '/system/informationsheet/AssetInfo',
    method: 'get',
    params: query
  })
}

// 2、点击某个时段获取该时段内的收益数据
export function getCondition(condition) {
  return request({
    url: '/system/recordsheet/list/' + condition,
    method: 'get'
  })
}
// 卡卷列表
export function getCardRollList(params) {
  return request({
    url: '/system/memberCoupons/list' ,
    method: 'get',
    params
  })
}

// 卡卷列表
export function getCardRollUse(activationCode) {
  return request({
    url: '/system/memberCoupons/useMemberCoupons/'+activationCode ,
    method: 'get',

  })
}



// WEBPACK FOOTER //
// ./src/api/accept/account/account.js